import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

export class AuthStateModel {
  user: any;
}

@State<AuthStateModel>({
  name: 'auth',
  defaults: {
    user: {},
  },
})
@Injectable()
export class AuthState {
  constructor() {}
}
